import { render, staticRenderFns } from "./AllotmentDescription.vue?vue&type=template&id=7ace164a&"
import script from "./AllotmentDescription.vue?vue&type=script&lang=ts&"
export * from "./AllotmentDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports